import React from "react";
import { createFragmentContainer, graphql } from "react-relay";
import styled from "styled-components";
import { InfoLabel } from "../../components/InfoLabel";
import FlatButton from "../../components/input/FlatButton";
import { PageSection } from "../../components/PageSection";
import Spacer from "../../components/Spacer";
import Table from "../../components/Table/Table";
import { Account_account } from "./__generated__/Account_account.graphql";

const UserItem = styled.div``;

const UserName = styled.div`
  font-weight: 500;
  display: flex;
`;

const UserEmail = styled.div`
  color: #9092c0;
  font-size: 12px;
`;

const UserTag = styled.div<{ background: string }>`
  font-size: 9px;
  background: ${(props) => props.background};
  padding: 4px 10px;
  border-radius: 3px;
  font-weight: 600;
  margin-left: 15px;
  color: white;
`;

const SoonTag = styled.div`
  font-size: 9px;
  background: orange;
  padding: 4px 10px;
  border-radius: 3px;
  font-weight: 600;
  margin-left: 15px;
  color: white;
`;

type Props = {
  account: Account_account;
};

function Account({ account }: Props) {
  console.log("account", account);
  return (
    <div>
      <PageSection
        title="Basic info"
        // extraItems={
        //   <FlatButton darkenOnHover color='#5C6EF8'>
        //     Update account details
        //   </FlatButton>
        // }
      >
        <InfoLabel label={"Team Name"}>{account.name}</InfoLabel>
      </PageSection>
      <Spacer vertical spacing={5} />
      <PageSection
        title="Team"
        subtitle="Bring your whole organisation on board."
        extraItems={
          <FlatButton darkenOnHover color="#5C6EF8">
            Add a team member <SoonTag>Coming soon</SoonTag>
          </FlatButton>
        }
      >
        <Table
          rows={account.team?.map((item) => item) ?? []}
          columns={[
            {
              headerName: "Name",
              component: (user) => (
                <UserItem>
                  <UserName>
                    {user.firstName} {user.lastName}
                    <UserTag
                      background={
                        user.membership.role === "OWNER" ? "#5c6ef8" : "#a7a8b3"
                      }
                    >
                      {user.membership.role}
                    </UserTag>
                  </UserName>
                  <UserEmail>{user.email}</UserEmail>
                </UserItem>
              ),
              flex: 1,
            },
          ]}
          onRowClick={() => {}}
        />
      </PageSection>
      <Spacer vertical spacing={5} />
    </div>
  );
}

export default createFragmentContainer(Account, {
  account: graphql`
    fragment Account_account on Account {
      name
      team {
        id
        firstName
        lastName
        email
        membership {
          role
        }
      }
    }
  `,
});
